export class PersonalData {
    constructor(
        public email: String = '',
        public name: String = '',
        public sirName: String = '',
        public phone: String = '',
        public allowFromGroup: String = '',
        public locationGroupId: any = [],
        public currentLocation: any = [],
        public retailerIps: any = ''

    ) { }
}